import { awaitDataServiceFetcher } from '@dxb-web-ui-framework/common/domain/RestfulDataTransfer/DataService/DataServiceFetchers';
import { ICurrencyRepository } from '../entities/ICurrencyRepository';
import { Currency } from '../entities';
import { currencyDTOToCurrencyAdapter } from './';

class CurrencyRepositoryImpl implements ICurrencyRepository {
  constructor() {
    this.GetCurrencies = this.GetCurrencies.bind(this);
  }

  GetCurrencies(): Promise<Currency[]> {
    return awaitDataServiceFetcher({
      payload: {
        method: 'GET',
        url: '/secure-web/api/private/transfers/parameters/currencies',
        dataAdapter: currencyDTOToCurrencyAdapter,
      },
    });
  }
}

export { CurrencyRepositoryImpl };
